import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import TeamHero from './components/TeamHero';
import Leadership from './components/Leadership';
import OurValues from './components/OurValues';
import JoinTeam from './components/JoinTeam';

export default function TeamPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <TeamHero />
      <Leadership />
      <OurValues />
      <JoinTeam />
      <Footer />
    </div>
  );
}